"use client";

import { HeroSection } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import { measurementVW } from "../../../../public/images/floor-plans";

const Hero = () => {
  const tC = useTranslations("common");
  const t = useTranslations("salesOptimizedFloorPlans.hero");

  return (
    <HeroSection
      image={measurementVW}
      alt={"Firmenwagen mit Grundriss Schmiede Logo und Farben"}
      tab={t("tab")}
      title={t("title")}
      text={t("text")}
      linkTitle={tC("optimizeNow")}
      href={"/user/order-measurement-service"}
      height={400}
    />
  );
};

export default Hero;
